import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFoundPage.css';
import { useSEO } from '../lib/seo';

export default function NotFoundPage() {
  useSEO({
    title: '404 — Page Not Found',
    description: 'The page you are looking for does not exist.',
    noindex: true,
  });

  const navigate = useNavigate();

  return (
    <main className="nf">
      <div className="nf__inner">
        <span className="nf__plant">🌿</span>
        <div className="nf__code">404</div>
        <h1 className="nf__title">Page not found</h1>
        <p className="nf__desc">
          Looks like this page wandered off into the jungle.
          Let's get you back to greener ground.
        </p>
        <div className="nf__actions">
          <Link to="/" className="nf__btn nf__btn--primary">
            Go home
          </Link>
          <button
            className="nf__btn nf__btn--ghost"
            onClick={() => navigate(-1)}
          >
            Go back
          </button>
        </div>
      </div>
    </main>
  );
}